import { Key as KeyIcon } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonFunction } from 'src/utils/commonFunctions/common-function.component';
import { CommonHelper } from 'src/utils/commonHelper';
import { useReAuth } from 'src/utils/reAuth/ReAuthContext';
import { useToaster } from 'src/utils/toaster/toasterContext';
import FacebookIcon from '../../assets/facebook.svg';
import GBusinessIcon from '../../assets/google-my-business-logo.svg';
import InstagramIcon from '../../assets/instagram.svg';
import LinkedInIcon from '../../assets/linked_in.svg';
import PinterestIcon from '../../assets/pinterest-icon.svg';
import TikTokIcon from '../../assets/tiktok.svg';
import TwitterIcon from '../../assets/twitter.svg';
import YoutubeIcon from '../../assets/youtube.png';
import CommonReAuthenticateComponent from '../integration/commonReAuthenticate';
import ConnectedMediaComponent from '../new-post-new/connected-media.component';
import PinterestCreateBoard from '../new-post-new/post-condition/pinterest-create-board';
import { PostUtil } from '../new-post-new/post-util';
import Spinner from 'src/utils/Loader/spinner';

dayjs.extend(utc);
dayjs.extend(timezone);

const EditAutomationPost = ({ handleClose, handleSuccess, automationId }) => {
  const { t: translate } = useTranslation();
  const curentBrandTime = CommonHelper.getBrandTimeZoneTime();
  const [connectedProfiles, setConnectedProfiles] = useState([]);
  const [targetConnectedProfiles, setTargetConnectedProfiles] = useState([]);
  const [sourceProfile, setSourceProfile] = useState(null);
  const [targetProfiles, setTargetProfiles] = useState([]);
  const [timesForTargets, setTimesForTargets] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedBoards, setSelectedBoards] = useState({});
  const [pinterestCreateBoardOpen, setPinterestCreateBoardOpen] = useState(false);
  const [selectedPopOverAccount, setSelectedPopOverAccount] = useState();
  const [reAuthenticateOpen, setReAuthenticateOpen] = useState(false);
  const { showToast } = useToaster();
  const { checkAndTriggerReAuth } = useReAuth();
  const is24HourFormat = CommonHelper.GetBrandInfoFromLocalStorage('is_24_hour_format');
  const hasIntegratationPermission = CommonHelper.CheckForPermissionAvailableForUser(
    CommonHelper.PermissionList.INTEGRATE_PERMISSION
  );

  const theme = useTheme();

  useEffect(() => {
    FetchAutomationPostView();
  }, []);

  const FetchAutomationPostView = () => {
    setLoader(true);
    let getProps = {
      url: `${userModuleURL.FetchAutomationPostView}${automationId}`,
      successCallback: fetchAutomationPostViewSuccessCallback,
      failureCallback: fetchAutomationPostViewFailureCallback,
    };
    HttpServices.Get(getProps);
  };
  const fetchAutomationPostViewFailureCallback = (message) => {
    setLoader(false);
    showToast(message, 'e');
  };
  const fetchAutomationPostViewSuccessCallback = (data) => {
    setLoader(false);
    const { automation_post_details, connected_profiles } = data;
    let sNetworks = connected_profiles?.filter(
      (a) =>
        (a.service_name.toUpperCase() === PostUtil.ServiceName.INSTAGRAM ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.FACEBOOK ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.THREADS ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.YOUTUBE ||
          (a.service_name.toUpperCase() === PostUtil.ServiceName.LINKEDIN && a.profile_type == 'PAGE') ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.GBUSINESS) &&
        a.is_enabled
    );
    let tNetworks = connected_profiles?.filter(
      (a) =>
        (a.service_name.toUpperCase() === PostUtil.ServiceName.INSTAGRAM ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.YOUTUBE ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.FACEBOOK ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.LINKEDIN ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.TIKTOK ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.TWITTER ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.THREADS ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.PINTEREST ||
          a.service_name.toUpperCase() === PostUtil.ServiceName.GBUSINESS) &&
        a.is_enabled
    );
    const sourceProfileId = automation_post_details?.automation_post.source_connected_profile_id;
    setSourceProfile(sourceProfileId);

    setConnectedProfiles(sNetworks || []);
    setTargetConnectedProfiles(tNetworks || []);

    const initialTargetProfiles = automation_post_details?.mappings
      .map((mapping) => {
        const targetProfile = tNetworks.find((profile) => profile.id === mapping.target_connected_profile_id);
        return targetProfile;
      })
      .filter(Boolean);
    setTargetProfiles(initialTargetProfiles);
   const initialTimes = {};
    // Set initial selected boards ← THIS WAS MISSING
    const initialBoards = {};

    automation_post_details.mappings.forEach((mapping) => {
      const times = mapping.post_hour_and_minutes.map((val) => CommonHelper.getBrandTimeZoneTime(val));
      initialTimes[mapping.target_connected_profile_id] = times || [];

      // Pre-select board if exists (especially for Pinterest)
      if (mapping.board_id) {
        initialBoards[mapping.target_connected_profile_id] = mapping.board_id;
      }
    });
    setTimesForTargets(initialTimes);
    setSelectedBoards(initialBoards);
    checkAndTriggerReAuth(connectedProfiles);
  };

  const handleSubmitAutomation = () => {
    if (!sourceProfile) {
      showToast(translate('automation.please_select_source_profile'), 'e');
      return;
    }

    if (targetProfiles.length === 0) {
      showToast(translate('automation.please_select_one_target_file'), 'e');
      return;
    }

    const isSourceInTargets = targetProfiles.some((target) => target.id === sourceProfile);
    if (isSourceInTargets) {
      showToast(translate('automation.source_and_target_cannot_same'), 'e');
      return;
    }

    let isValid = true;

    for (const target of targetProfiles) {
      const times = timesForTargets[target.id] || [];

      if (times.length === 0) {
        showToast(`${translate('automation.please_add_one_for')} ${target.profile_name}.`, 'e');
        return;
      }

      for (let i = 0; i < times.length; i++) {
        for (let j = i + 1; j < times.length; j++) {
          const timeDiff = Math.abs(dayjs(times[i]).diff(dayjs(times[j]), 'minute'));
          if (timeDiff < 10) {
            isValid = false;
            showToast(
              `${translate('automation.time_for')} ${target.profile_name} ${translate(
                'automation.must_be_atleast'
              )} 10 ${translate('automation.minute_apart')}`,
              'e'
            );
            break;
          }
        }
        if (!isValid) break;
      }
      if (!isValid) break;
    }

    if (!isValid) {
      return;
    }
    setLoading(true);
    const targetProfilesWithTimes = targetProfiles.map((target) => ({
      target_profile_id: target.id,
      post_times: timesForTargets[target.id] || [],
      board_id: selectedBoards[target.id] || null,
    }));

    const payload = {
      automation_post_id: automationId,
      source_profile_id: sourceProfile,
      source_service_name: connectedProfiles.find((a) => a.id === sourceProfile)?.service_name,
      target_profiles_with_times: targetProfilesWithTimes,
    };

    HttpServices.Post({
      url: userModuleURL.editAutomation,
      body: payload,
      successCallback: editAutomationPostSuccessCallback,
      failureCallback: editAutomationPostFailureCallback,
    });
  };
  const handleCreateBoard = () => {
    setPinterestCreateBoardOpen(true);
  };
  const handlePinterestBoardClose = () => {
    setPinterestCreateBoardOpen(false);
  };
  const NewBoardCreationCallback = (newBoard, profileId) => {
    setTargetConnectedProfiles((prevProfiles) => {
      return prevProfiles.map((profile) => {
        if (profile.id === profileId) {
          return {
            ...profile,
            pinterst_boards: [...profile.pinterst_boards, newBoard],
          };
        }
        return profile;
      });
    });
    setPinterestCreateBoardOpen(false);
  };
  const editAutomationPostFailureCallback = (message) => {
    showToast(message, 'e');
    setLoading(false);
  };
  const editAutomationPostSuccessCallback = (data, message) => {
    handleSuccess(message);
    setLoading(false);
  };

  const handleBoardChange = (targetId, boardId) => {
    setSelectedBoards((prevBoards) => ({
      ...prevBoards,
      [targetId]: boardId,
    }));
  };

  const handleTimeChange = (targetId, index, newTime) => {
    if (newTime) {
      const convertedTime = CommonHelper.getBrandTimeZoneTime(newTime);
      setTimesForTargets((prevTimes) => {
        const updatedTimes = { ...prevTimes };
        if (!updatedTimes[targetId]) {
          updatedTimes[targetId] = [];
        }
        updatedTimes[targetId][index] = convertedTime;
        return updatedTimes;
      });
    }
  };

  const addTimeForTarget = (targetId) => {
    setTimesForTargets((prevTimes) => {
      const updatedTimes = { ...prevTimes };
      if (!updatedTimes[targetId]) {
        updatedTimes[targetId] = [];
      }
      updatedTimes[targetId].push(curentBrandTime);
      return updatedTimes;
    });
  };
  const removeTimeForTarget = (targetId, index) => {
    setTimesForTargets((prevTimes) => {
      const updatedTimes = { ...prevTimes };
      if (updatedTimes[targetId]) {
        updatedTimes[targetId] = updatedTimes[targetId].filter((_, i) => i !== index);
        if (updatedTimes[targetId].length === 0) {
          delete updatedTimes[targetId];
        }
      }
      return updatedTimes;
    });
  };

  const handleSourceProfile = (e) => {
    setSourceProfile(e.target.value);
  };
  const handleCloseReauthenticate = () => {
    setReAuthenticateOpen(false);
    setSelectedPopOverAccount(null);
  };
  const handleProfileClick = (profile) => {
    setSelectedPopOverAccount(profile);
    setReAuthenticateOpen(true);
  };
  const handleNetworks = (newValue) => {
    setTargetProfiles(newValue);
    setTimesForTargets((prevTimes) => {
      const updatedTimes = { ...prevTimes };
      newValue.forEach((target) => {
        if (!updatedTimes[target.id]) {
          updatedTimes[target.id] = [curentBrandTime];
        }
      });
      return updatedTimes;
    });
  };
  const connectedMediaProps = {
    configuredSocialMedia: targetConnectedProfiles,
    selectedSocialMedias: targetProfiles,
    handleNetworks,
    handleProfileClick,
  };
  return (
    <Dialog
      open
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          minHeight: '300px',
          maxHeight: '90vh',
          height: '90vh',
        },
      }}
    >
      {loader ? (
        <Spinner />
      ) : (
        <DialogContent dividers>
          <Typography variant="h5" gutterBottom>
            {translate('automation.edit_cross_post')}
          </Typography>
          <Typography style={{ color: theme.palette.text.secondary, ...theme.typography.subtitle2 }}>
            {translate('automation.please_select_source_profile')}
          </Typography>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <Select
              value={sourceProfile}
              onChange={handleSourceProfile}
              displayEmpty
              disabled
              renderValue={(selected) =>
                selected ? (
                  connectedProfiles.find((profile) => profile.id === selected) ? (
                    CommonFunction.InitialAccountBadgeWithName(
                      connectedProfiles.find((profile) => profile.id === selected)
                    )
                  ) : (
                    selected
                  )
                ) : (
                  <Typography color="text.secondary">{translate('automation.please_select_source_profile')}</Typography>
                )
              }
            >
              {connectedProfiles.map((profile) => (
                <MenuItem
                  key={profile.id}
                  value={profile.id}
                  style={{
                    pointerEvents: !profile.is_active ? 'none' : 'auto',
                  }}
                >
                  {CommonFunction.InitialAccountBadgeWithName(profile)}
                  {!profile.is_active && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (hasIntegratationPermission) {
                          handleProfileClick(profile);
                        }
                      }}
                      sx={{
                        ml: 2,
                        pointerEvents: 'auto',
                        borderRadius: 1,
                        backgroundColor: theme.palette.error.main,
                        color: theme.palette.error.contrastText,
                        '&:hover': {
                          backgroundColor: theme.palette.error.dark,
                          boxShadow: theme.shadows[3],
                        },
                      }}
                      startIcon={<KeyIcon fontSize="small" />}
                    >
                      {translate('common.reauthenticate')}
                    </Button>
                  )}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography style={{ color: theme.palette.text.secondary, ...theme.typography.subtitle2 }} sx={{ mt: 2 }}>
            {translate('automation.select_target_profile')}
          </Typography>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <ConnectedMediaComponent {...connectedMediaProps} />
          </FormControl>
          <Box
            sx={{
              mt: 2,
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
            }}
          >
            {targetProfiles.map((target) => {
              const targetProfile = targetConnectedProfiles.find((profile) => profile.id === target.id);
              const times = timesForTargets[target.id] || [];
              const isPinterest = targetProfile?.service_name.toUpperCase() === PostUtil.ServiceName.PINTEREST;
              const boards = isPinterest ? targetProfile?.pinterst_boards : [];

              return (
                <Card
                  key={target.id}
                  sx={{
                    flex: '1 1 calc(33.333% - 16px)',
                    minWidth: '300px',
                    maxWidth: '100%',
                    mb: 2,
                    boxShadow: 3,
                    borderRadius: 2,
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardContent>
                    <Avatar
                      src={targetProfile.profile_image || targetProfile.profile_name || targetProfile.id}
                      alt={targetProfile.profile_name || targetProfile.id}
                      sx={{ height: 30, width: 30, bgcolor: 'primary.main' }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                      {targetProfile?.profile_name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                      {targetProfile?.service_name.toUpperCase()}
                    </Typography>
                    {isPinterest && (
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>{translate('automation.select_board')}</InputLabel>
                        <Select
                          value={selectedBoards[target.id] || ''}
                          onChange={(e) => handleBoardChange(target.id, e.target.value)}
                          label={translate('automation.select_board')}
                        >
                          {boards.map((board) => (
                            <MenuItem key={board.board_id} value={board.board_id}>
                              {board.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <Button
                          variant="contained"
                          onClick={handleCreateBoard}
                          sx={{ whiteSpace: 'nowrap', mt: 2 }} // Prevents the button text from wrapping
                        >
                          {translate('automation.create_board')}
                        </Button>
                        {pinterestCreateBoardOpen && (
                          <PinterestCreateBoard
                            handleClose={handlePinterestBoardClose}
                            profileId={targetProfile.id}
                            NewBoardCreationCallback={(data) => NewBoardCreationCallback(data, targetProfile.id)}
                          />
                        )}
                      </FormControl>
                    )}
                    <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 2, alignItems: 'center', mt: 2 }}>
                      {times.map((time, index) => (
                        <Box
                          key={index}
                          sx={{
                            flex: '1 1 calc(33.333% - 16px)',
                            minWidth: '200px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                              label={`Select Time to Post ${index + 1}`}
                              value={dayjs(time) || null}
                              ampm={!is24HourFormat}
                              onChange={(newTime) => handleTimeChange(target.id, index, newTime)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 1,
                                    },
                                  }}
                                />
                              )}
                            />
                          </LocalizationProvider>
                          <IconButton
                            onClick={() => removeTimeForTarget(target.id, index)}
                            sx={{
                              color: theme.palette.error.main,
                              '&:hover': {
                                backgroundColor: theme.palette.error.light,
                              },
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      ))}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton
                          onClick={() => addTimeForTarget(target.id)}
                          sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            '&:hover': {
                              backgroundColor: theme.palette.primary.dark,
                            },
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                          {translate('automation.add_another_time')}
                        </Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        </DialogContent>
      )}

      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.cancel')}
        </Button>
        <LoadingButton
          loading={isLoading}
          onClick={handleSubmitAutomation}
          variant="contained"
          color="primary"
          disabled={targetProfiles.length === 0 || !sourceProfile}
        >
          {translate('automation.edit_automation')}
        </LoadingButton>
      </DialogActions>
      {reAuthenticateOpen && (
        <CommonReAuthenticateComponent
          selectedPopOverAccount={selectedPopOverAccount}
          getConnectedNetworks={FetchAutomationPostView}
          onClose={handleCloseReauthenticate}
        />
      )}
    </Dialog>
  );
};

export default EditAutomationPost;
